<template>
  <div class="interface-add">
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line" >
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">屏幕名称：</span>
        </div>
        <el-input v-model="dashboardName" size="small" style="flex: 1;" />
      </div>

      <div class="interface-config-main">
        <div class="interface-config-main-left">
          <!--<p style="margin: 25px 0;text-align: center;color: #999999;" v-if="!modifyModuleName">请先点击修改按钮</p>-->
          <draggable element="div" :list="allModuleList" group="allModule" class="screen-top-list" v-if="modifyModuleName==='allModule'">
            <div v-for="item in allModuleList" class="main-screen-top-item" :key="item.name" >
              <span>{{item.name}}</span>
            </div>
          </draggable>

          <draggable element="div" :list="modifyModuleLeftList" :group="modifyModuleName" class="screen-top-list" v-if="modifyModuleName && modifyModuleName!=='allModule'">
            <div v-for="item in modifyModuleLeftList" class="main-screen-top-item" :key="item.name" >
              <span>{{item.showName}}</span>
            </div>
          </draggable>
          <button-confirm @confirm="saveAndReturn" value="保存并返回修改布局" style="margin: 20px auto" v-if="modifyModuleName && modifyModuleName!=='allModule'" />
        </div>
        <div class="page-right">
          <div class="screen-config-main-top">
            <div class="screen-config-main-top-tip">
              <i class="el-icon-damai-tishi" style="color: #00a0e6;margin-right: 5px"></i>
              <span>双击具体模块可配置模块内部数据</span>
            </div>
            <draggable element="div" :list="dashboardMangerList" group="dashboard" class="screen-config-interface-list" >
              <div v-for="dashboard in dashboardMangerList" class="screen-config-interface-item" :key="dashboard.dashboardName" >
                <span>{{dashboard.dashboardName}}</span>
              </div>
            </draggable>
            <!--<button-cancel @cancel="modifyConfig" v-if="!modifyModuleName" value="修改" />-->
            <!--<button-confirm @confirm="saveConfig" value="保存" v-else />-->
          </div>

          <div class="interface-config-main-right">
            <div class="main-screen-title" @dblclick="changeDetailConfig([], '标题')">{{yqDashboardTitle}}</div>
            <draggable element="div" :list="dashboardMangerChooseList" class="screen-config-interface-list" group="dashboard" :class="{'has-box-shadow': modifyModuleName==='allModule' }">
              <div v-for="dashboard in dashboardMangerChooseList" class="screen-config-interface-item" :key="dashboard.dashboardName" >
                <span>{{dashboard.dashboardName}}</span>
              </div>
            </draggable>
            <!--<div class="main-screen-top-div">-->
            <!--<draggable element="div" :list="mainScreenTopChooseList" class="main-screen-top" group="screenTop" >-->
            <!--<div v-for="item in mainScreenTopChooseList" class="main-screen-top-item" :key="item.name" >-->
            <!--<span>{{item.name}}</span>-->
            <!--</div>-->
            <!--</draggable>-->
            <!--<i class="el-icon-edit" @click="changeScreenTop"></i>-->
            <!--</div>-->
            <div class="main-screen-main">
              <!--左-->
              <draggable element="div" :list="chooseLeftList" group="allModule" :disabled="modifyModuleName!=='allModule'" class="main-screen-main-left" :class="{'has-box-shadow': modifyModuleName==='allModule' }">
                <div v-for="item in chooseLeftList" :key="item.name" :class="'screen-height-'+item.size" @dblclick="changeDetailConfig(chooseLeftList, item)" :style="{boxShadow: modifyModuleName===item.name?'0 0 15px #00A0E6': '0' }">
                  <div class="box-title" v-if="item.name !== '园区展示图'">{{item.name}}</div>
                  <!--<img :src="yqDashboardPic[0]" v-if="item.name === '园区展示图' && yqDashboardPic.length > 0" style="width: 100%;height: 100%;border-radius: 10px;position: absolute;top: 0;left: 0;opacity: 0.8;" alt="">-->
                  <el-carousel style="width: 100%;height: 100%;position: absolute;top: 0;left: 0;" v-if="item.name === '园区展示图' && yqDashboardPic.length > 0">
                    <el-carousel-item v-for="imgUrl in yqDashboardPic" :key="imgUrl" >
                      <img :src="imgUrl" alt="" style="width: 100%;height: 100%;border-radius: 10px;position: absolute;top: 0;left: 0;opacity: 0.8;">
                    </el-carousel-item>
                  </el-carousel>
                  <img src="../../../assets/interface/noPic.png" v-if="item.name === '园区展示图' && yqDashboardPic.length === 0" style="width: 100%;height: 100%;border-radius: 10px;position: absolute;top: 0;left: 0;opacity: 0.8;" alt="">

                  <!--子内容-->
                  <draggable element="div" :list="item.child" :group="item.name" :disabled="modifyModuleName!==item.name" :class="item.size === '1' ? 'info-main-child-1' : 'info-main-child-2'" v-if="item.name !== '基础展示'">
                    <div v-for="child in item.child" :id="child.idName" :style="{width: child.width,height: child.height}">
                      <div v-if="child.name" class="box-title">{{child.name}}</div>
                      <div  :class="child.idName" ></div>
                    </div>
                  </draggable>

                  <div :class="item.size === '1' ? 'info-main-child-1' : 'info-main-child-2'" v-else>
                    <div v-for="child in item.child" :id="child.idName" :style="{width: child.width,height: child.height}">
                      <div v-if="child.name" class="box-title">{{child.name}}</div>
                      <draggable element="div" :list="child.ringData" :group="item.name" :disabled="modifyModuleName!==item.name" class="basic-info" >
                        <div v-for="ring in child.ringData" :key="ring.name" :class="ring.eName"></div>
                      </draggable>
                    </div>
                  </div>
                </div>
              </draggable>

              <!--中-->
              <draggable element="div" :list="chooseMiddleList" group="allModule" :disabled="modifyModuleName!=='allModule'" class="main-screen-main-middle" :class="{'has-box-shadow': modifyModuleName==='allModule' }">
                <div v-for="item in chooseMiddleList" :key="item.name" :class="'screen-height-'+item.size" @dblclick="changeDetailConfig(chooseLeftList, item)" :style="{boxShadow: modifyModuleName===item.name?'0 0 15px #00A0E6': '0'}">
                  <div class="box-title" v-if="item.name !== '园区展示图'">{{item.name}}</div>
                  <!--<img :src="yqDashboardPic[0]" v-if="item.name === '园区展示图' && yqDashboardPic.length > 0" style="width: 100%;height: 100%;border-radius: 10px;position: absolute;top: 0;left: 0;opacity: 0.8;" alt="">-->
                  <el-carousel style="width: 100%;height: 100%;position: absolute;top: 0;left: 0;" v-if="item.name === '园区展示图' && yqDashboardPic.length > 0">
                    <el-carousel-item v-for="imgUrl in yqDashboardPic" :key="imgUrl" >
                      <img :src="imgUrl" alt="" style="width: 100%;height: 100%;border-radius: 10px;position: absolute;top: 0;left: 0;opacity: 0.8;">
                    </el-carousel-item>
                  </el-carousel>
                  <img src="../../../assets/interface/noPic.png" v-if="item.name === '园区展示图' && yqDashboardPic.length === 0" style="width: 100%;height: 100%;border-radius: 10px;position: absolute;top: 0;left: 0;opacity: 0.8;" alt="">
                  <!--子内容-->
                  <draggable element="div" :list="item.child" :group="item.name" :disabled="modifyModuleName!==item.name" :class="item.size === '1' ? 'info-main-child-1' : 'info-main-child-2'" v-if="item.name !== '基础展示'">
                    <div v-for="child in item.child" :id="child.idName" :style="{width: child.width,height: child.height}">
                      <div v-if="child.name" class="box-title">{{child.name}}</div>
                      <div  :class="child.idName" ></div>
                    </div>
                  </draggable>

                  <div :class="item.size === '1' ? 'info-main-child-1' : 'info-main-child-2'" v-else>
                    <div v-for="child in item.child" :id="child.idName" :style="{width: child.width,height: child.height}">
                      <div v-if="child.name" class="box-title">{{child.name}}</div>
                      <draggable element="div" :list="child.ringData" :group="item.name" :disabled="modifyModuleName!==item.name" class="basic-info" >
                        <div v-for="ring in child.ringData" :key="ring.name" :class="ring.eName"></div>
                      </draggable>
                    </div>
                  </div>
                </div>
              </draggable>

              <!--右-->
              <draggable element="div" :list="chooseRightList" group="allModule" :disabled="modifyModuleName!=='allModule'" class="main-screen-main-right" :class="{'has-box-shadow': modifyModuleName==='allModule' }">
                <div v-for="item in chooseRightList" :key="item.name" :class="'screen-height-'+item.size" @dblclick="changeDetailConfig(chooseRightList, item)" :style="{boxShadow: modifyModuleName===item.name?'0 0 15px #00A0E6': '0'}">
                  <div class="box-title" v-if="item.name !== '园区展示图'">{{item.name}}</div>
                  <!--<img :src="yqDashboardPic[0]" v-if="item.name === '园区展示图' && yqDashboardPic.length > 0" style="width: 100%;height: 100%;border-radius: 10px;position: absolute;top: 0;left: 0;opacity: 0.8;" alt="">-->
                  <el-carousel style="width: 100%;height: 100%;position: absolute;top: 0;left: 0;" v-if="item.name === '园区展示图' && yqDashboardPic.length > 0">
                    <el-carousel-item v-for="imgUrl in yqDashboardPic" :key="imgUrl" >
                      <img :src="imgUrl" alt="" style="width: 100%;height: 100%;border-radius: 10px;position: absolute;top: 0;left: 0;opacity: 0.8;">
                    </el-carousel-item>
                  </el-carousel>
                  <img src="../../../assets/interface/noPic.png" v-if="item.name === '园区展示图' && yqDashboardPic.length === 0" style="width: 100%;height: 100%;border-radius: 10px;position: absolute;top: 0;left: 0;opacity: 0.8;" alt="">
                  <!--子内容-->
                  <draggable element="div" :list="item.child" :group="item.name" :disabled="modifyModuleName!==item.name" :class="item.size === '1' ? 'info-main-child-1' : 'info-main-child-2'" v-if="item.name !== '基础展示'">
                    <div v-for="child in item.child" :id="child.idName" :style="{width: child.width,height: child.height}">
                      <div v-if="child.name" class="box-title">{{child.name}}</div>
                      <div  :class="child.idName" ></div>
                    </div>
                  </draggable>

                  <div :class="item.size === '1' ? 'info-main-child-1' : 'info-main-child-2'" v-else>
                    <div v-for="child in item.child" :id="child.idName" :style="{width: child.width,height: child.height}">
                      <div v-if="child.name" class="box-title">{{child.name}}</div>
                      <draggable element="div" :list="child.ringData" :group="item.name" :disabled="modifyModuleName!==item.name" class="basic-info" >
                        <div v-for="ring in child.ringData" :key="ring.name" :class="ring.eName"></div>
                      </draggable>
                    </div>
                  </div>
                </div>
              </draggable>
            </div>
          </div>

          <button-cancel @cancel="toDataPage" v-if="!modifyModuleName" value="预览" style="width: 160px;margin: 30px auto 0" />
        </div>
      </div>



      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>

    <el-dialog
      title="修改园区展示图"
      :visible.sync="imgDialogVisible"
      width="40%">
      <input id="uploadGuidedGraph" name="file" accept="image/*" type="file"
             @change="upData2" style="display: none" />
      <div style="margin: 20px 0;display: flex;justify-content: flex-start;align-items: center;flex-wrap: wrap;">
        <div class="imgBox" v-for="(img,imgIndex) in yqDashboardPicChange" :key="img">
          <img class="packBg" :src="img" style="width: 160px;height: 90px;"/>

          <div class="imgMask">
            <i class="el-icon-delete" @click="deleteImg(imgIndex)"></i>
          </div>
        </div>

        <a class="newly2" @click="upImg2">
          <span><i class="el-icon-plus"></i></span>
          <span>点击上传</span>
        </a>
        <!--<a class="upload2" @click="upImg2" v-if="yqDashboardPicChange">-->
        <!---->
        <!--<b>重新上传</b>-->
        <!--</a>-->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="cancelChangePic">取 消</el-button>
        <el-button size="mini" type="primary" @click="confirmChangePic">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="修改标题"
      :visible.sync="titleDialogVisible"
      width="40%">
      <div style="margin: 40px 0;">
        <el-input v-model="modifyYqDashboardTitle" style="width: 280px;margin: 0 auto;" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="cancelChangeTitle">取 消</el-button>
        <el-button size="mini" type="primary" @click="confirmChangeTitle">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="修改视频"
      :visible.sync="videoDialogVisible"
      width="40%">
      <div style="display: flex;justify-content: flex-start;align-items: center;margin: 20px 30px;" v-for="(video, videoIndex) in videoUrlList" :key="videoIndex">
        <b class="red">*</b>
        <span class="line-text">
            视频ID<el-tooltip class="item" effect="dark" content="暂只支持优酷视频ID" placement="top" style="margin: 0 5px">
              <i class="el-icon-question"></i>
            </el-tooltip>：
          </span>
        <el-input v-model="video.url" size="small" style="width: 280px;margin: 0;" />
        <i class="el-icon-circle-plus-outline" style="line-height: 32px;font-size: 18px;color: #00A0E6;margin: 0 10px 0 10px;cursor: pointer;" @click="addVideoLine()" v-if="videoIndex === videoUrlList.length - 1"></i>
        <i class="el-icon-remove-outline" style="line-height: 32px;font-size: 18px;color: #f25721;margin: 0 0 0 10px;cursor: pointer;" @click="removeVideoLine(index)" v-if="videoIndex < videoUrlList.length && videoIndex !== 0"></i>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="cancelChangeVideo">取 消</el-button>
        <el-button size="mini" type="primary" @click="confirmChangeVideo">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import {getObjectURL} from '../../../utils/toBase64'
  import $ from 'jquery'
  import {api} from '../../api/InterfaceConfig'
  import {nError, nSuccess} from '../../../utils/notice'
  import {errorHandler} from '../../../utils/errorHandler'
  import UploadImgList from '../../../components/Input/UploadImgList'
  import Clipboard from 'clipboard'
  import draggable from 'vuedraggable'
  import {bus} from '../../../utils/bus'

  export default {
    components: {
      UploadImgList,
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb,
      draggable,},
    name: 'interface-add',
    data () {
      return {
        breadcrumb: [{
          value: '智慧大脑',
          name: 'interface-manage'
        }, {
          value: '屏幕配置'
        }],
        mainTitle: '修改屏幕',
        subheading: '',

        defaultModuleList: [
          {
            name: '门禁总览',
            size: '1',
            idName: '',
            child: [
              {
                name: '',
                showName: '门禁设备',
                width: '34%',
                height: '100%',
                size: '1',
                idName: 'accessMeter',
                component: 'commonRing',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              },
              {
                name: '',
                showName: '进出记录',
                width: '66%',
                height: '100%',
                size: '1',
                idName: 'accessLine',
                component: 'commonLine',
                xAxis: [],
                yAxis: [],
                series: [],
                ringData: [],
              }
            ]
          },
          {
            name: '基础展示',
            size: '1',
            idName: '',
            child: [
              {
                name: '',
                width: '100%',
                height: '100%',
                size: '1',
                idName: 'basicInfo',
                component: 'basicInfo',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [
                  { name: '管理面积', showName: '管理面积', eName: 'area', value: '0', unit: 'm²', width: '50%'},
                  { name: '房源总数', showName: '房源总数', eName: 'fy', value: '0', unit: '间', width: '50%'},
                  { name: '招商房源', showName: '招商房源', eName: 'zsfy', value: '0', unit: '间', width: '50%'},
                  { name: '房源出租率', showName: '房源出租率', eName: 'czl', value: '0', unit: '', width: '50%'},
                  { name: '入驻企业', showName: '入驻企业', eName: 'qy', value: '0', unit: '家', width: '50%'},
                  { name: '园区人员', showName: '园区人员', eName: 'ry', value: '0', unit: '人', width: '50%'},
                ],
              }
            ]
          },
          {
            name: '预约总览',
            size: '2',
            idName: '',
            child: [
              {
                name: '',
                showName: '预约次数',
                width: '100%',
                height: '50%',
                size: '1',
                idName: 'appointmentBar',
                component: 'commonStackingBar',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              },
              {
                name: '',
                showName: '预约费',
                width: '100%',
                height: '50%',
                size: '1',
                idName: 'appointmentLine',
                component: 'commonLine',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              }
            ]
          },
          {
            name: '园区展示图',
            size: '1',
            noBg: true,
            idName: '',
            child: [
              {
                name: '',
                width: '100%',
                height: '100%',
                size: '1',
                idName: 'yqImg',
                component: 'yqImg',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              }
            ]
          },
          {
            name: '视频',
            size: '1',
            noBg: true,
            idName: '',
            child: [
              {
                name: '',
                width: '100%',
                height: '100%',
                size: '1',
                idName: 'yqVideo',
                component: 'youku',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              }
            ]
          },
          {
            name: '园区动态',
            size: '2',
            idName: '',
            child: [
              {
                name: '',
                showName: '当日园区流量',
                width: '100%',
                height: '40%',
                size: '1',
                idName: 'flowNumber',
                component: 'flowNumber',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              },
              {
                name: '',
                showName: '7日园区流量',
                width: '100%',
                height: '60%',
                size: '1',
                idName: 'recordLine',
                component: 'personInfoTable',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              }
            ]
          },
          {
            name: '电控总览',
            size: '1',
            idName: '',
            child: [
              {
                name: '',
                showName: '电控设备',
                width: '34%',
                height: '100%',
                size: '1',
                idName: 'electronicMeter',
                component: 'commonRing',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              },
              {
                name: '',
                showName: '7日用电量',
                width: '66%',
                height: '100%',
                size: '1',
                idName: 'electronicLine',
                component: 'commonLine',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              }
            ]
          },
          {
            name: '报修总览',
            size: '2',
            idName: '',
            child: [
              {
                name: '',
                showName: '报修次数',
                width: '100%',
                height: '50%',
                size: '1',
                idName: 'repairBar',
                component: 'commonStackingBar',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              },
              {
                name: '',
                showName: '报修费',
                width: '100%',
                height: '50%',
                size: '1',
                idName: 'repairLine',
                component: 'commonLine',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              }
            ]
          },
          {
            name: '访客总览',
            size: '1',
            idName: '',
            child: [
              {
                name: '',
                width: '100%',
                height: '100%',
                size: '1',
                idName: 'visitorLine',
                component: 'commonLine',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              }
            ]
          },
          {
            name: '开票总览',
            size: '1',
            idName: '',
            child: [
              {
                name: '',
                width: '100%',
                height: '100%',
                size: '1',
                idName: 'invoiceLine',
                component: 'commonLine',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              }
            ]
          },
          {
            name: '梯控总览',
            size: '1',
            idName: '',
            child: [
              {
                name: '',
                width: '100%',
                height: '100%',
                size: '1',
                idName: 'liftLine',
                component: 'commonLine',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              }
            ]
          },
          {
            name: '严选服务',
            size: '1',
            idName: '',
            child: [
              {
                name: '',
                width: '100%',
                height: '100%',
                size: '1',
                idName: 'valueaddBar',
                component: 'commonStackingBar',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              }
            ]
          },
          {
            name: '消息总览',
            size: '1',
            idName: '',
            child: [
              {
                name: '',
                width: '100%',
                height: '100%',
                size: '1',
                idName: 'messageLine',
                component: 'commonLine',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              }
            ]
          },
          {
            name: '招商总览',
            size: '1',
            idName: '',
            child: [
              {
                name: '',
                width: '100%',
                height: '100%',
                size: '1',
                idName: 'contractLine',
                component: 'commonLine',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              }
            ]
          },
          {
            name: '活动总览',
            size: '1',
            idName: '',
            child: [
              {
                name: '',
                showName: '报名比例',
                width: '34%',
                height: '100%',
                size: '1',
                idName: 'enrollMeter',
                component: 'commonRing',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              },
              {
                name: '',
                showName: '报名统计',
                width: '66%',
                height: '100%',
                size: '1',
                idName: 'enrollBar',
                component: 'commonStackingBar',
                xAxis: [],
                yAxis: [],
                series: [],
                ringData: [],
              }
            ]
          },

          {
            name: '设备总览',
            size: '1',
            noBg: true,
            idName: '',
            child: [
              {
                name: '',
                width: '100%',
                height: '100%',
                size: '1',
                idName: 'deviceStatistics',
                component: 'deviceStatistics',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              }
            ]
          },
          {
            name: '报警总览',
            size: '1',
            noBg: true,
            idName: '',
            child: [
              {
                name: '',
                width: '100%',
                height: '100%',
                size: '1',
                idName: 'alarmOverview',
                component: 'alarmOverview',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              }
            ]
          },
        ],

        allModuleList: [
          {
            name: '门禁总览',
            size: '1',
            idName: '',
            child: [
              {
                name: '',
                showName: '门禁设备',
                width: '34%',
                height: '100%',
                size: '1',
                idName: 'accessMeter',
                component: 'commonRing',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              },
              {
                name: '',
                showName: '进出记录',
                width: '66%',
                height: '100%',
                size: '1',
                idName: 'accessLine',
                component: 'commonLine',
                xAxis: [],
                yAxis: [],
                series: [],
                ringData: [],
              }
            ]
          },
          {
            name: '基础展示',
            size: '1',
            idName: '',
            child: [
              {
                name: '',
                width: '100%',
                height: '100%',
                size: '1',
                idName: 'basicInfo',
                component: 'basicInfo',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [
                  { name: '管理面积', showName: '管理面积', eName: 'area', value: '0', unit: 'm²', width: '50%'},
                  { name: '房源总数', showName: '房源总数', eName: 'fy', value: '0', unit: '间', width: '50%'},
                  { name: '招商房源', showName: '招商房源', eName: 'zsfy', value: '0', unit: '间', width: '50%'},
                  { name: '房源出租率', showName: '房源出租率', eName: 'czl', value: '0', unit: '', width: '50%'},
                  { name: '入驻企业', showName: '入驻企业', eName: 'qy', value: '0', unit: '家', width: '50%'},
                  { name: '园区人员', showName: '园区人员', eName: 'ry', value: '0', unit: '人', width: '50%'},
                ],
              }
            ]
          },
          {
            name: '预约总览',
            size: '2',
            idName: '',
            child: [
              {
                name: '',
                showName: '预约次数',
                width: '100%',
                height: '50%',
                size: '1',
                idName: 'appointmentBar',
                component: 'commonStackingBar',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              },
              {
                name: '',
                showName: '预约费',
                width: '100%',
                height: '50%',
                size: '1',
                idName: 'appointmentLine',
                component: 'commonLine',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              }
            ]
          },
          {
            name: '园区展示图',
            size: '1',
            noBg: true,
            idName: '',
            child: [
              {
                name: '',
                width: '100%',
                height: '100%',
                size: '1',
                idName: 'yqImg',
                component: 'yqImg',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              }
            ]
          },
          {
            name: '视频',
            size: '1',
            noBg: true,
            idName: '',
            child: [
              {
                name: '',
                width: '100%',
                height: '100%',
                size: '1',
                idName: 'yqVideo',
                component: 'youku',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              }
            ]
          },
          {
            name: '园区动态',
            size: '2',
            idName: '',
            child: [
              {
                name: '',
                showName: '当日园区流量',
                width: '100%',
                height: '40%',
                size: '1',
                idName: 'flowNumber',
                component: 'flowNumber',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              },
              {
                name: '',
                showName: '7日园区流量',
                width: '100%',
                height: '60%',
                size: '1',
                idName: 'recordLine',
                component: 'personInfoTable',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              }
            ]
          },
          {
            name: '电控总览',
            size: '1',
            idName: '',
            child: [
              {
                name: '',
                showName: '电控设备',
                width: '34%',
                height: '100%',
                size: '1',
                idName: 'electronicMeter',
                component: 'commonRing',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              },
              {
                name: '',
                showName: '7日用电量',
                width: '66%',
                height: '100%',
                size: '1',
                idName: 'electronicLine',
                component: 'commonLine',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              }
            ]
          },
          {
            name: '报修总览',
            size: '2',
            idName: '',
            child: [
              {
                name: '',
                showName: '报修次数',
                width: '100%',
                height: '50%',
                size: '1',
                idName: 'repairBar',
                component: 'commonStackingBar',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              },
              {
                name: '',
                showName: '报修费',
                width: '100%',
                height: '50%',
                size: '1',
                idName: 'repairLine',
                component: 'commonLine',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              }
            ]
          },
          {
            name: '访客总览',
            size: '1',
            idName: '',
            child: [
              {
                name: '',
                width: '100%',
                height: '100%',
                size: '1',
                idName: 'visitorLine',
                component: 'commonLine',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              }
            ]
          },
          {
            name: '开票总览',
            size: '1',
            idName: '',
            child: [
              {
                name: '',
                width: '100%',
                height: '100%',
                size: '1',
                idName: 'invoiceLine',
                component: 'commonLine',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              }
            ]
          },
          {
            name: '梯控总览',
            size: '1',
            idName: '',
            child: [
              {
                name: '',
                width: '100%',
                height: '100%',
                size: '1',
                idName: 'liftLine',
                component: 'commonLine',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              }
            ]
          },
          {
            name: '严选服务',
            size: '1',
            idName: '',
            child: [
              {
                name: '',
                width: '100%',
                height: '100%',
                size: '1',
                idName: 'valueaddBar',
                component: 'commonStackingBar',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              }
            ]
          },
          {
            name: '消息总览',
            size: '1',
            idName: '',
            child: [
              {
                name: '',
                width: '100%',
                height: '100%',
                size: '1',
                idName: 'messageLine',
                component: 'commonLine',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              }
            ]
          },
          {
            name: '招商总览',
            size: '1',
            idName: '',
            child: [
              {
                name: '',
                width: '100%',
                height: '100%',
                size: '1',
                idName: 'contractLine',
                component: 'commonLine',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              }
            ]
          },
          {
            name: '活动总览',
            size: '1',
            idName: '',
            child: [
              {
                name: '',
                showName: '报名比例',
                width: '34%',
                height: '100%',
                size: '1',
                idName: 'enrollMeter',
                component: 'commonRing',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              },
              {
                name: '',
                showName: '报名统计',
                width: '66%',
                height: '100%',
                size: '1',
                idName: 'enrollBar',
                component: 'commonStackingBar',
                xAxis: [],
                yAxis: [],
                series: [],
                ringData: [],
              }
            ]
          },

          {
            name: '设备总览',
            size: '1',
            idName: '',
            child: [
              {
                name: '',
                width: '100%',
                height: '100%',
                size: '1',
                idName: 'deviceStatistics',
                component: 'deviceStatistics',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              }
            ]
          },
          {
            name: '报警总览',
            size: '1',
            idName: '',
            child: [
              {
                name: '',
                width: '100%',
                height: '100%',
                size: '1',
                idName: 'alarmOverview',
                component: 'alarmOverview',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              }
            ]
          },
        ],

        chooseLeftList: [],
        chooseMiddleList: [],
        chooseRightList: [],

        modifyModuleName: 'allModule',
        modifyModuleLeftList: [],

        imgDialogVisible: false,
        titleDialogVisible: false,
        pictureBase64: '',
        yqDashboardTitle: '',
        modifyYqDashboardTitle: '',
        yqDashboardPic: [],
        yqDashboardPicChange: [],

        videoDialogVisible: false,
        videoUrlList: [],
        reqVideoUrlList: [],

        dashboardName: '',

        defaultDashboardMangerList: [],
        dashboardMangerList: [],
        dashboardMangerChooseList: []
      }
    },
    created () {

      this.getDashboardMangerByCode(this.$route.params.id)
    },
    methods: {
      getDashboardMangerList () {
        this.$axios.post(api.getDashboardMangerList, {})
          .then(res => {
            let data = res.data.data
            let dashboardMangerList = []
            data.map(v => {
              if(v.code !== this.$route.params.id) {
                dashboardMangerList.push(v)
              }
            })
            this.defaultDashboardMangerList = dashboardMangerList
          })
          .catch(errorHandler('获取大屏列表失败'))
      },
      // 获取配置
      getDashboardMangerByCode (code) {
        this.$axios.get(`${api.getDashboardMangerByCode}/${code}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              let hasModule = []
              let allModuleList = []
              let topCofigName = []
              this.dashboardName = data.dashboardName
              this.reqVideoUrlList = data.videoUrlList || []
              let videoUrlList = []
              this.reqVideoUrlList.map(v => {
                let obj = {
                  url: v
                }
                videoUrlList.push(obj)
              })
              this.videoUrlList = videoUrlList
              if (data.yqDashboardConfig) {
                this.dashboardMangerChooseList = data.yqDashboardConfig.topConfig || []
                this.chooseLeftList = data.yqDashboardConfig.leftConfig || []
                this.chooseMiddleList = data.yqDashboardConfig.middleConfig || []
                this.chooseRightList = data.yqDashboardConfig.rightConfig || []
                this.chooseLeftList.map(left => {
                  hasModule.push(left.name)
                })
                this.chooseMiddleList.map(middle => {
                  hasModule.push(middle.name)
                })
                this.chooseRightList.map(right => {
                  hasModule.push(right.name)
                })
                this.dashboardMangerChooseList.map(top => {
                  topCofigName.push(top.dashboardName)
                })
              }
              if (data.yqDashboardTitle) {
                this.yqDashboardTitle = data.yqDashboardTitle
              } else {
                this.yqDashboardTitle = bus.global.yqName
              }
              this.modifyYqDashboardTitle = this.yqDashboardTitle
              this.yqDashboardPic = data.yqDashboardPicList || []
              this.yqDashboardPicChange = data.yqDashboardPicList || []

              this.defaultModuleList.map(module => {
                if (hasModule.indexOf(module.name) === -1) {
                  allModuleList.push(module)
                }
              })

              let dashboardMangerList = []
              this.defaultDashboardMangerList.map(dashboard => {
                if (topCofigName.indexOf(dashboard.dashboardName) === -1) {
                  dashboardMangerList.push(dashboard)
                }
              })

              this.allModuleList = allModuleList
              this.dashboardMangerList = dashboardMangerList
              this.getDashboardMangerList()
            }
          })
          .catch(errorHandler('获取失败'))
      },

      changeScreenTop () {
        this.currentArea = 'screenTop'
      },

      // 保存并返回整体修改
      saveAndReturn () {
        this.modifyModuleName = 'allModule'
      },

      // 修改整体
      modifyConfig () {
        this.modifyModuleName = 'allModule'
      },

      // 修改具体模块
      changeDetailConfig (list, item) {
        if (item === '标题') {
          this.titleDialogVisible = true
        } else if (item.name === '基础展示') {
          let childChoose = []
          let modifyModuleLeftList = []
          item.child.map(itemChild => {
            itemChild.ringData.map(ring => {
              childChoose.push(ring.showName)
            })
          })
          this.modifyModuleName = item.name
          this.defaultModuleList.map(allModule => {
            if (allModule.name === item.name) {
              allModule.child.map(childItem => {
                childItem.ringData.map(ringItem => {
                  if (childChoose.indexOf(ringItem.showName) === -1) {
                    modifyModuleLeftList.push(ringItem)
                  }
                })
              })
            }
          })
          this.modifyModuleLeftList = modifyModuleLeftList
        } else if (item.name === '园区展示图') {
          // 修改图片
          this.imgDialogVisible = true
        } else if (item.name === '视频') {
          // 修改视频
          this.videoDialogVisible = true
          if (this.videoUrlList.length === 0) {
            this.videoUrlList.push({
              url: ''
            })
          }
        } else {
          let childChoose = []
          let modifyModuleLeftList = []
          item.child.map(itemChild => {
            childChoose.push(itemChild.idName)
          })
          this.modifyModuleName = item.name
          this.defaultModuleList.map(allModule => {
            if (allModule.name === item.name) {
              allModule.child.map(childItem => {
                if (childChoose.indexOf(childItem.idName) === -1) {
                  modifyModuleLeftList.push(childItem)
                }
              })
            }
          })
          this.modifyModuleLeftList = modifyModuleLeftList
        }

      },

      // 获取配置
      getConfig () {
        this.$axios.post(`${api.getConfig}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              let hasModule = []
              let allModuleList = []
              if (data.yqDashboardConfig) {
                this.chooseLeftList = data.yqDashboardConfig.leftConfig || []
                this.chooseMiddleList = data.yqDashboardConfig.middleConfig || []
                this.chooseRightList = data.yqDashboardConfig.rightConfig || []
                this.chooseLeftList.map(left => {
                  hasModule.push(left.name)
                })
                this.chooseMiddleList.map(middle => {
                  hasModule.push(middle.name)
                })
                this.chooseRightList.map(right => {
                  hasModule.push(right.name)
                })
              }
              if (data.yqDashboardTitle) {
                this.yqDashboardTitle = data.yqDashboardTitle
              } else {
                this.yqDashboardTitle = data.yqName
              }
              this.modifyYqDashboardTitle = this.yqDashboardTitle
              this.yqDashboardPic = data.yqDashboardPic

              this.defaultModuleList.map(module => {
                if (hasModule.indexOf(module.name) === -1) {
                  allModuleList.push(module)
                }
              })

              this.allModuleList = allModuleList
            }
          })
          .catch(errorHandler('获取失败'))
      },

      // 保存配置
      saveConfig () {
        this.$axios.post(`${api.saveConfig}`, {
          yqDashboardTitle: this.yqDashboardTitle,
          yqDashboardPic: this.yqDashboardPic,
          yqDashboardConfig: {
            leftConfig: this.chooseLeftList,
            middleConfig: this.chooseMiddleList,
            rightConfig: this.chooseRightList
          }
        })
          .then(res => {
            if (res.data.retCode === 1) {
              this.modifyModuleName = ''
              this.getConfig()
              this.modifyYqDashboardTitle = false
            }
          })
          .catch(errorHandler('保存失败'))
      },

      // 上传图片
      upData2: function () {
        let that = this
        const oFReader = new FileReader()
        const file = document.getElementById('uploadGuidedGraph').files[0]
        // if (file.size > 1024 * 1024) {
        //   nError('上传图片不能大于1M')
        //   return false
        // }
        oFReader.readAsDataURL(file)
        oFReader.onloadend = function (oFRevent) {
          const src = oFRevent.target.result
          that.pictureBase64 = src
          that.uploadPicture()
        }
        let obj = document.getElementById('uploadGuidedGraph')
        obj.files = []
      },
      upImg2: function () {
        document.getElementById('#uploadBackgroundImg')
        $('#uploadGuidedGraph')
          .click() // 隐藏了input:file样式后，点击头像就可以本地上传
          .on('change', function () {
            // const objUrl = getObjectURL(this.files[0])
            // if (objUrl) {
            //   $('#pic2').attr('src', objUrl)
            // }
          })
      },

      // 上传图片
      uploadPicture () {
        // const loading = this.$loading({
        //   lock: true,
        //   text: '请稍后',
        //   spinner: 'el-icon-loading',
        //   background: 'rgba(0, 0, 0, 0.7)'
        // })
        this.$axios.post(api.uploadImg, {
          picData: this.pictureBase64
        })
          .then(res => {
            if (res.data.retCode === 1) {
              let imgUrl = res.data.data
              this.yqDashboardPicChange.push(imgUrl)
            } else {
              // 提示信息，需引入Message
              nError('图片上传失败')
            }
          })
          .catch(errorHandler('图片上传失败'))
      },

      // 确认修改图片
      confirmChangePic () {
        if (this.yqDashboardPicChange.length === 0) {
          nError('请先选择图片')
        } else {
          this.yqDashboardPic = this.yqDashboardPicChange
          this.imgDialogVisible = false
          console.log(this.yqDashboardPic)
        }
      },

      // 取消修改图片
      cancelChangePic () {
        this.yqDashboardPicChange = []
        this.imgDialogVisible = false
      },

      deleteImg (imgIndex) {
        this.yqDashboardPicChange.splice(imgIndex, 1)
      },

      confirmChangeTitle () {
        this.yqDashboardTitle = this.modifyYqDashboardTitle
        this.titleDialogVisible = false
      },

      // 取消修改标题
      cancelChangeTitle () {
        this.modifyYqDashboardTitle = this.yqDashboardTitle
        this.titleDialogVisible = false
      },

      // 添加一行
      addVideoLine () {
        let obj = {
          url: '',
        }
        this.videoUrlList.push(obj)
      },

      // 移除一行
      removeVideoLine (index) {
        this.videoUrlList.splice(index, 1)
      },

      // 取消修改视频
      cancelChangeVideo () {
        this.videoDialogVisible = false
      },

      // 确认修改视频
      confirmChangeVideo () {
        let reqVideoUrlList = []
        this.videoUrlList.map(v => {
          if (v.url) {
            reqVideoUrlList.push(v.url)
          }
        })
        if (reqVideoUrlList.length === 0) {
          nError('请输入视频ID')
          return false
        } else {
          this.reqVideoUrlList = reqVideoUrlList
          this.videoDialogVisible = false
        }
      },

      // 预览
      toDataPage () {
        window.open(`http://yq.damaiiot.com/dataPage.html#/login_without/${bus.global.yqCode}/${bus.global.accountCode}`, '_blank')
      },

      toManagePage () {
        this.$router.push({
          name: 'interface-manage'
        })
      },

      confirm () {
        if (!this.dashboardName) {
          nError('请输入屏幕名称')
          return false
        }
        this.$axios.post(api.updateDashboardManger, {
          code: this.$route.params.id,
          dashboardName: this.dashboardName,
          yqDashboardConfig: {
            topConfig: this.dashboardMangerChooseList,
            leftConfig: this.chooseLeftList,
            middleConfig: this.chooseMiddleList,
            rightConfig: this.chooseRightList
          },
          yqDashboardPicList: this.yqDashboardPic,
          yqDashboardTitle: this.yqDashboardTitle,
          videoUrlList: this.reqVideoUrlList
        })
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('修改成功')
              this.toManagePage()
            }
          })
          .catch(errorHandler('修改失败'))
      },
      cancel () {
        this.toManagePage()
      },
    },
  }
</script>

<style scoped>
  form {
    width: 96%;
    margin: 0 auto;
  }
  .red {
    color: #FF0000;
    vertical-align: sub;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
  }
  .form-line>div {
    margin-right: 20px;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 140px;
    line-height: 32px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 110px 0 140px;
    margin: 40px auto 0;
    display: flex;
    justify-content: space-between;
  }
  .newly2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    border: 1px dashed #D7D7D7;
    margin-right: 20px;
    position: relative;
  }
  .newly2 span {
    display: block;
    width: 100%;
    color: #999999;
    margin: 0;
    padding: 0;
    text-align: center;
  }
  .newly2 span:first-child {
    font-size: 36px;
    line-height: 120px;
    position: absolute;
    top: 15px;
  }
  .newly2 span:last-child {
    font-size: 14px;
    line-height: 50px;
    position: absolute;
    bottom: 0;
  }
  .upload2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    background-size: 100% 100%;
    position: relative;
  }

  .upload2 img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
  .upload2 b {
    display: inline-block;
    width: 100%;
    line-height: 21px;
    color: white;
    background-color: #989796;
    text-align: center;
    position: absolute;
    bottom: 0;
    opacity: .7;
  }
</style>

<style lang="less">
  .el-switch {
    height: 30px;
  }

  .interface-add {
    .interface-config-main {
      flex: 1;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .interface-config-main-left {
        width: 160px;
        height: 100%;
        border-right: 1px solid #eeeeee;
        .screen-top-list {
          width: 160px;
          padding: 20px 20px 20px 10px;
          height: 631.5px;
          overflow-y: auto;
          .main-screen-top-item {
            cursor: pointer;
            line-height: 60px;
            color: #ffffff;
            background: #75bfe6;
            margin-bottom: 10px;
            border-radius: 10px;
            border-bottom: 1px solid #ffffff;
          }
        }
      }

      .basic-info {
        width: 100%;
        height: 100%;
        padding: 0 0.2rem;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .basic-info-item {
          width: 33%;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          text-align: left;

        }

        .area {
          width: 33%;
          height: 50%;
          background: url("../../../assets/interface/area.png") no-repeat center;
          background-size: 100% auto;
        }
        .fy {
          width: 33%;
          height: 50%;
          background: url("../../../assets/interface/fy.png") no-repeat center;
          background-size: 100% auto;
        }
        .zsfy {
          width: 33%;
          height: 50%;
          background: url("../../../assets/interface/zsfy.png") no-repeat center;
          background-size: 100% auto;
        }
        .czl {
          width: 33%;
          height: 50%;
          background: url("../../../assets/interface/czl.png") no-repeat center;
          background-size: 100% auto;
        }
        .qy {
          width: 33%;
          height: 50%;
          background: url("../../../assets/interface/qy.png") no-repeat center;
          background-size: 100% auto;
        }
        .ry {
          width: 33%;
          height: 50%;
          background: url("../../../assets/interface/ry.png") no-repeat center;
          background-size: 100% auto;
        }
      }


      .page-right {
        height: 100%;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        .screen-config-main-top {
          width: 1000px;
          .screen-config-main-top-tip {
            padding-left: 30px;
            color: #666666;
            display: flex;
            justify-content: flex-start;
            align-items: center;
          }
          .screen-config-interface-list {
            margin: 10px 0;
            padding: 0 30px;
            height: 32px;
            overflow-x: auto;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .screen-config-interface-item {
              margin-right: 10px;
              padding: 0 10px;
              cursor: pointer;
              line-height: 30px;
              color: #fff;
              background: #75bfe6;
              border-radius: 10px;
              border-bottom: 1px solid #fff;
            }
          }
        }
        /*右侧主屏*/
        .interface-config-main-right {
          color: #ffffff;
          width: 1000px;
          height: 562.5px;
          border: 1px solid #eeeeee;
          margin-left: 20px;
          background: url("../../../assets/interface_bg.png") no-repeat;
          background-size: 100% 100%;
          .screen-config-interface-list {
            width: 960px;
            height: 24px;
            margin: 8px auto;
            display: flex;
            justify-content: center;
            .screen-config-interface-item {
              line-height: 24px;
              margin: 0 10px;
              cursor: pointer;
            }
          }
          .main-screen-title {
            font-size: 20px;
            height: 30px;
            line-height: 30px;
            font-weight: 500;
            color: #ffffff;
          }
          .main-screen-top-div {
            position: relative;
            border: 1px solid #eeeeee;
            width: 900px;
            height: 80px;
            padding: 0 10px;
            line-height: 60px;
            margin: 0 auto;
            .main-screen-top {
              display: flex;
              justify-content: space-between;
              align-items: center;
              .main-screen-top-item {
                cursor: pointer;
                color: #ffffff;
                background: #75bfe6;
                padding: 0 10px;
              }
            }

            .el-icon-edit {
              font-size: 18px;
              position: absolute;
              right: -20px;
              top: 0;
              display: none;
            }
          }

          .main-screen-top-div:hover {
            .el-icon-edit {
              display: block;
            }
          }

          .main-screen-main {
            width: 960px;
            margin: 10px auto 0;
            display: flex;
            justify-content: space-between;

            .has-box-shadow {
              box-shadow: 0 0 15px #00a0e6;
            }
            .screen-height-1 {
              width: 300px;
              height: 180px;
              padding: 6px;
              background: url("../../../assets/top_frame.png") no-repeat;
              background-size: 100% 100%;
              display: flex;
              justify-content: flex-start;
              flex-direction: column;
              position: relative;
            }

            .screen-height-2 {
              width: 300px;
              height: 260px;
              padding: 6px;
              background: url("../../../assets/bottom_frame.png") no-repeat;
              background-size: 100% 100%;
              display: flex;
              justify-content: flex-start;
              flex-direction: column;
            }

            .main-screen-main-left {
              width: 300px;
              height: 460px;
              /*border: 1px solid #eeeeee;*/
              display: flex;
              justify-content: space-between;
              flex-direction: column;
            }
            .main-screen-main-middle {
              width: 320px;
              height: 460px;
              /*border: 1px solid #eeeeee;*/
              display: flex;
              justify-content: space-between;
              flex-direction: column;
              .screen-height-1 {
                width: 320px;
                height: 180px;
                background: url("../../../assets/top_frame.png") no-repeat;
                background-size: 100% 100%;
              }
              .screen-height-2 {
                width: 320px;
                height: 260px;
                background: url("../../../assets/bottom_frame.png") no-repeat;
                background-size: 100% 100%;
              }
            }
            .main-screen-main-right {
              width: 300px;
              height: 460px;
              /*border: 1px solid #eeeeee;*/
              display: flex;
              justify-content: space-between;
              flex-direction: column;
            }


            .box-title {
              color: #ffffff;
              font-size: 12px;
              line-height: 30px;
            }

            .info-main-child-1 {
              display: flex;
              justify-content: space-between;
              flex: 1;
            }

            .info-main-child-2 {
              display: flex;
              justify-content: space-between;
              flex-direction: column;
              flex: 1;
            }

            .info-main-child-1>div {
              margin: 0 auto;
            }

            .info-main-child-2>div>div {
              flex: 1;
            }

            #accessMeter {
              display: flex;
              justify-content: flex-start;
              flex-direction: column;
              .accessMeter {
                flex: 1;
                width: 100%;
                height: 100%;
                background: url("../../../assets/interface/accessMeter.jpg") no-repeat center;
                background-size: auto 100%;
              }
            }

            #accessLine {
              display: flex;
              justify-content: flex-start;
              flex-direction: column;
              .accessLine {
                flex: 1;
                width: 100%;
                height: 100%;
                background: url("../../../assets/interface/accessLine.png") no-repeat center;
                background-size: 100% auto;
              }
            }

            #appointmentBar {
              display: flex;
              justify-content: flex-start;
              flex-direction: column;
              .appointmentBar {
                flex: 1;
                width: 100%;
                height: 100%;
                background: url("../../../assets/interface/appointmentBar.png") no-repeat center;
                background-size: auto 100%;
              }
            }
            #appointmentLine {
              display: flex;
              justify-content: flex-start;
              flex-direction: column;
              .appointmentLine {
                flex: 1;
                width: 100%;
                height: 100%;
                background: url("../../../assets/interface/appointmentLine.jpg") no-repeat center;
                background-size: auto 100%;
              }
            }
            #flowNumber {
              display: flex;
              justify-content: flex-start;
              flex-direction: column;
              .flowNumber {
                flex: 1;
                width: 100%;
                height: 100%;
                background: url("../../../assets/interface/flowNumber.png") no-repeat center;
                background-size: auto 100%;
              }
            }
            #recordLine {
              display: flex;
              justify-content: flex-start;
              flex-direction: column;
              .recordLine {
                flex: 1;
                width: 100%;
                height: 100%;
                background: url("../../../assets/interface/recordLine.jpg") no-repeat center;
                background-size: 100% auto;
              }
            }
            #repairBar {
              display: flex;
              justify-content: flex-start;
              flex-direction: column;
              .repairBar {
                flex: 1;
                width: 100%;
                height: 100%;
                background: url("../../../assets/interface/repairBar.jpg") no-repeat center;
                background-size: auto 100%;
              }
            }
            #repairLine {
              display: flex;
              justify-content: flex-start;
              flex-direction: column;
              .repairLine {
                flex: 1;
                width: 100%;
                height: 100%;
                background: url("../../../assets/interface/repairLine.jpg") no-repeat center;
                background-size: auto 100%;
              }
            }
            #electronicMeter {
              display: flex;
              justify-content: flex-start;
              flex-direction: column;
              .electronicMeter {
                flex: 1;
                width: 100%;
                height: 100%;
                background: url("../../../assets/interface/electronicMeter.jpg") no-repeat center;
                background-size: auto 100%;
              }
            }
            #electronicLine {
              display: flex;
              justify-content: flex-start;
              flex-direction: column;
              .electronicLine {
                flex: 1;
                width: 100%;
                height: 100%;
                background: url("../../../assets/interface/electronicLine.jpg") no-repeat center;
                background-size: auto 100%;
              }
            }

            #visitorLine {
              display: flex;
              justify-content: flex-start;
              flex-direction: column;
              .visitorLine {
                flex: 1;
                width: 98%;
                height: 100%;
                background: url("../../../assets/interface/visitorLine.png") no-repeat center;
                background-size: 100% 100%;
              }
            }
            #invoiceLine {
              display: flex;
              justify-content: flex-start;
              flex-direction: column;
              .invoiceLine {
                flex: 1;
                width: 98%;
                height: 100%;
                background: url("../../../assets/interface/invoiceLine.jpg") no-repeat center;
                background-size: 100% 100%;
              }
            }
            #liftLine {
              display: flex;
              justify-content: flex-start;
              flex-direction: column;
              .liftLine {
                flex: 1;
                width: 98%;
                height: 100%;
                background: url("../../../assets/interface/liftLine.png") no-repeat center;
                background-size: 100% 100%;
              }
            }
            #valueaddLine {
              display: flex;
              justify-content: flex-start;
              flex-direction: column;
              .valueaddLine {
                flex: 1;
                width: 98%;
                height: 100%;
                background: url("../../../assets/interface/valueaddLine.jpg") no-repeat center;
                background-size: 100% 100%;
              }
            }
            #messageLine {
              display: flex;
              justify-content: flex-start;
              flex-direction: column;
              .messageLine {
                flex: 1;
                width: 98%;
                height: 100%;
                background: url("../../../assets/interface/valueaddLine.jpg") no-repeat center;
                background-size: 100% 100%;
              }
            }
            #contractLine {
              display: flex;
              justify-content: flex-start;
              flex-direction: column;
              .contractLine {
                flex: 1;
                width: 98%;
                height: 100%;
                background: url("../../../assets/interface/contractLine.jpg") no-repeat center;
                background-size: 100% 100%;
              }
            }
            #enrollMeter {
              display: flex;
              justify-content: flex-start;
              flex-direction: column;
              .enrollMeter {
                flex: 1;
                width: 98%;
                height: 100%;
                background: url("../../../assets/interface/enrollMeter.png") no-repeat center;
                background-size: 100% auto;
              }
            }
            #enrollBar {
              display: flex;
              justify-content: flex-start;
              flex-direction: column;
              .enrollBar {
                flex: 1;
                width: 98%;
                height: 100%;
                background: url("../../../assets/interface/enrollBar.jpg") no-repeat center;
                background-size: 100% 100%;
              }
            }
          }
        }
      }
    }

    .newly2 {
      display: inline-block;
      width: 160px;
      height: 90px;
      vertical-align: text-top;
      border: 1px dashed #D7D7D7;
      border-radius: 5px;
      margin-right: 20px;
      position: relative;
    }
    .newly2 span {
      display: block;
      width: 100%;
      color: #999999;
      margin: 0;
      padding: 0;
      text-align: center;
    }
    .newly2 span:first-child {
      font-size: 36px;
      line-height: 50px;
      position: absolute;
      top: 15px;
    }
    .newly2 span:last-child {
      font-size: 14px;
      line-height: 30px;
      position: absolute;
      bottom: 0;
    }
    .upload2 {
      display: inline-block;
      width: 160px;
      height: 90px;
      vertical-align: text-top;
      background-size: 100% 100%;
      position: relative;
    }

    .upload2 img {
      width: 100%;
      height: 100%;
      border-radius: 5px;
    }
    .upload2 b {
      display: inline-block;
      width: 100%;
      line-height: 21px;
      color: white;
      border-radius: 5px;
      background-color: #989796;
      text-align: center;
      position: absolute;
      bottom: 0;
      left: 0;
      opacity: .7;
    }

    .imgBox {
      width: 160px;
      height: 90px;
      margin-right: 10px;
      border: 1px solid #ffffff;
      position: relative;
    }
    .imgBox:hover {
      .imgMask {
        display: block;
      }
    }
    .imgMask {
      width: 160px;
      height: 90px;
      display: none;
      background-color: rgba(102, 102, 102, .7);
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      margin: 0 auto;
    }
    .imgMask i {
      width: 20px;
      color: #FFFFFF;
      line-height: 90px;
      font-size: 20px;
      position: absolute;
      left: 0;
      right: 0;
      margin: 0 auto;
    }
    .imgMask i:hover {
      cursor: pointer;
      color: #f25721;
    }
  }
</style>




// WEBPACK FOOTER //
// src/view/IntellectualBrain/InterfaceManage/InterfaceModify.vue